import { styled } from '@mui/material';
import Container from '../Container';

export const FullScreenContainer = styled(Container, {
    shouldForwardProp: (prop) => prop !== 'fullscreen',
})<{ fullscreen?: boolean }>(({ theme, fullscreen }) => ({
    height: '100%',
    zIndex: fullscreen ? theme.zIndex.fullScreenContainer : 0,
    minHeight: 400,
    position: fullscreen ? 'fixed' : 'static',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'auto',
}));
